<template>
    <div class="rate">
        <el-popover placement="top" width="60" popper-class="ratePopover" v-model="isShowRateOptions">
            <div class="rateOptions">
                <div v-for="r, index in rateOptions" :key="index" @click="setPlayRate(r)">
                    {{ r }}x
                </div>
            </div>
            <el-button slot="reference">{{ ratedisplay }}</el-button>
        </el-popover>
    </div>
</template>

<script>
export default {
    name: "Rate",
    props: {
        domId: {
            type: String,
            default: 'test1'
        }
    },
    components: {},
    data() {
        return {
            //播放速率
            rateOptions: [2.0, 1.75, 1.5, 1.0, 0.75, 0.5],
            isShowRateOptions: false,
            rate: 1,
        }
    },
    computed: {
        ratedisplay() {
            if (this.rate == 1) {
                return '倍速'
            } else {
                return this.rate + 'x'
            }
        }
    },
    methods: {
        toShowOptions() {
            this.isShowRateOptions = !this.isShowRateOptions
        },
        setPlayRate(val) {
            this.isShowRateOptions = false
            this.rate = val
            document.getElementById(this.domId).playbackRate = val
        }
    },
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.rate {
    cursor: pointer;
}
</style>
<style lang="scss">
.ratePopover {
    min-width: 60px;

    .rateOptions {
        width: 60px;
        height: 180px;
        background-color: #fff;
        // background-color: #817f7f5a;
        // position: absolute;
        // top: -185px;
        // right: 50px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
    }

    .rateOptions div {
        cursor: pointer;
        display: block;
        width: 100%;
        height: 30px;
        text-align: center;
        line-height: 30px;
    }

    .rateOptions div:hover {
        background-color: #cec9c95a;
        color: #409EFF;
    }
}
</style>